<template>
    <div>
        <el-form :model="reuionActivePropertyList" label-width="10px">
<!--            <el-form-item>-->
<!--                <div style="color: red">-->
<!--                    文案配置<br/>-->
<!--                    1、活动商品 配置要赠送的商品id 在单品管理页面找   <br/>-->
<!--                    2、  除了推文连接 其他标识不可以修改 <br/>-->
<!--                </div>-->
<!--            </el-form-item>-->
            <el-form-item>
                <el-table :data="list" stripe border center :size="GCONFIG.styleTableSize"
                          v-loading="loading" width="180">
                    <el-table-column type="index" label="序号" width="60">
                    </el-table-column>
                    <el-table-column prop="propertyName" width="110" label="配置名称">
                    </el-table-column>
                    <el-table-column prop="propertyKey" width="120" label="标识">
                    </el-table-column>
                    <el-table-column prop="propertyValue" label="内容">
                        <template slot-scope="scope">
                            <el-input v-model=scope.row.propertyValue clearable placeholder="这里配置文案内容"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="propertyRemark" width="200" label="文案说明">
                    </el-table-column>
                    <el-table-column label="操作" width="160" fixed="right">
                      <template slot="header" slot-scope="scope">
                        操作
                        <el-button type="primary" size="mini" @click="addProperty()" class="header-btn">新建</el-button>
                      </template>
                        <template slot-scope="scope">
                            <el-button type="danger" v-show="isEdit" size="mini"
                                       @click="saveActivePropertyForList(scope.row)">保存

                            </el-button>
                          <el-button type="warning" v-show="isEdit" size="mini"
                                     @click="deleteActiveProperty(scope.row)">删除

                          </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>
<!--            <el-form-item>-->
<!--                <el-button type="primary" size="mini" @click="saveActivePropertyList()">批量保存</el-button>-->
<!--            </el-form-item>-->
        </el-form>
      <el-dialog title="添加/修改活动属性" :visible.sync="showDialog">
        <el-form :model="activeProperty" label-width="120px" :rules="rules" ref="activeProperty">

          <el-form-item label="选择默认属性" prop="">
            <el-select v-model="propertyKey" clearable filterable placeholder="" @change="onChange()">
              <el-option
                  v-for="item in selectlist"
                  :key="item.propertyKey"
                  :label="item.propertyName"
                  :value="item.propertyKey">
              </el-option>
            </el-select>可用默认属性添加，也可以直接填写
          </el-form-item>

          <el-form-item label="配置名称" prop="propertyName" required >
            <el-input v-model="activeProperty.propertyName"  :disabled="readOnly"
                             placeholder="配置名称"></el-input>
          </el-form-item>
          <el-form-item label="标识" prop="propertyKey" required>
            <el-input v-model="activeProperty.propertyKey" :disabled="readOnly"
                             placeholder="标识"></el-input>
          </el-form-item>
          <el-form-item label="内容" prop="propertyValue" required>
            <el-input v-model="activeProperty.propertyValue"
                             placeholder="内容"></el-input>
          </el-form-item>
          <el-form-item label="文案说明" prop="propertyRemark" required>
            <el-input v-model="activeProperty.propertyRemark" :disabled="readOnly"
                             placeholder="文案说明"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="showDialog = false">取 消</el-button>
            <el-button type="primary" @click="saveActiveProperty(activeProperty)" class="header-btn">
              保 存
            </el-button>
          </el-form-item>

        </el-form>
      </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        saveActivePropertyApi,
        deleteActivePropertyApi,
        getActivePropertyList,
        saveActivePropertyListApi
    } from '../../api/api';
    export default {
        data() {
            return {
              propertyKey:'',
              activeProperty:{
                propertyName:'',
                propertyKey:'',
                propertyValue:'',
                propertyRemark:'',
                status: 1,
                bindCode:this.$route.query.bindCode
              },
              rules: {
                propertyName: [
                  { required: true, message: '请输入配置名称', trigger: 'blur' },
                  { min: 3, max: 40, message: '长度在 3 到 40 个字符', trigger: 'blur' }
                ],
                propertyKey: [
                  { required: true, message: '请输入标识', trigger: 'blur' },
                  { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
                ],
                propertyValue: [
                  { required: true, message: '请输入内容', trigger: 'blur' },
                ],
                propertyRemark: [
                  { required: true, message: '请输入标识文案说明', trigger: 'blur' },
                  { min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
                ],
              },

              list:[],
                selectlist: [
                    {
                        propertyName: '用户订单数',
                        propertyValue: '1',
                        propertyRemark: '限制用户下过X单及以上的用户参与,限制老用户领券,请填写1',
                        propertyId: '',
                        propertyKey: 'orderNum',
                        status: 1,
                        bindCode: ''
                    },
                    {
                        propertyName: '活动商品',
                        propertyValue: '',
                        propertyRemark: '活动商品 配置要赠送的商品id 在单品管理页面找',
                        propertyId: '',
                        propertyKey: 'productId',
                        status: 1,
                        bindCode: ''
                    },
                    {
                        propertyName: '分享成功文案',
                        propertyValue: '',
                        propertyRemark: '分享完后提示文案',
                        propertyId: '',
                        propertyKey: 'shareSuccessDesc',
                        status: 1,
                        bindCode: ''
                    },
                    {
                        propertyName: '礼物送完文案提示',
                        propertyValue: '礼物送完了，不能再分享提示文案',
                        propertyRemark: '礼物被领取完了给好友提示文案',
                        propertyId: '',
                        propertyKey: 'notHasGiftDesc',
                        status: 1,
                        bindCode: ''
                    },
                    {
                        propertyName: '不符合邀请条件用户文案提示',
                        propertyValue: '',
                        propertyRemark: '好友不是新用户点领取时提示文案',
                        propertyId: '',
                        propertyKey: 'notHasInviteQualification',
                        status: 1,
                        bindCode: ''
                    },
                    {
                        propertyName: '不允许自己邀请自己提示文案',
                        propertyValue: '仅限好友领取，不可自领',
                        propertyRemark: '不允许自己邀请自己提示文案',
                        propertyId: '',
                        propertyKey: 'notAllowSelfTakedDesc',
                        status: 1,
                        bindCode: ''
                    },
                    {
                        propertyName: '限新用户领取提示文案',
                        propertyValue: '仅限没有买过的新用户参与噢 ',
                        propertyRemark: '限新用户领取提示文案',
                        propertyId: '',
                        propertyKey: 'notAllowOldUserTakedDesc',
                        status: 1,
                        bindCode: ''
                    },
                    {
                        propertyName: '好友领取海报页面文案',
                        propertyValue: '亲爱的朋友，我想送你一份万里挑一的纯牛奶它来自每一万头奶牛中仅有不到1头的尼里拉菲奶牛,成长在五星级的环境中，吃的是甘蔗和菠萝，产出的纯牛奶 ',
                        propertyRemark: '好友领取海报页面文案',
                        propertyId: '',
                        propertyKey: 'takedPageDesc',
                        status: 1,
                        bindCode: ''
                    },
                    {
                        propertyName: '文章连接',
                        propertyValue: 'https://mp.weixin.qq.com/s/15GJYdJyfww5wfducDcpDw ',
                        propertyRemark: '填写未关注用户跳转推文连接',
                        propertyId: '',
                        propertyKey: 'articleUrl',
                        status: 1,
                        bindCode: ''
                    },
                    {
                        propertyName: '最少邀请用户数',
                        propertyValue: '1 ',
                        propertyRemark: '邀请用户要领取奖励，最少需要邀请的用户数',
                        propertyId: '',
                        propertyKey: 'baseInviteNum',
                        status: 1,
                        bindCode: ''
                    },
                    {
                        propertyName: 'IP限制数',
                        propertyValue: '5',
                        propertyRemark: 'IP限制数，默认5',
                        propertyId: '',
                        propertyKey: 'ipLimitCount',
                        status: 1,
                        bindCode: ''
                    },
                    {
                        propertyName: '收货地址限制数',
                        propertyValue: '3',
                        propertyRemark: '收货地址限制数，默认0',
                        propertyId: '',
                        propertyKey: 'addressLimitCount',
                        status: 1,
                        bindCode: ''
                    },
                    {
                        propertyName: '小程序后买牛奶限制数',
                        propertyValue: '3',
                        propertyRemark: '小程序后买牛奶限制数，默认0',
                        propertyId: '',
                        propertyKey: 'miniBuyMilkLimitCount',
                        status: 1,
                        bindCode: ''
                    },
                    {
                        propertyName: '全域购买牛奶限制数',
                        propertyValue: '1',
                        propertyRemark: '全域购买牛奶限制数，默认0',
                        propertyId: '',
                        propertyKey: 'allBuyMilkLimitCount',
                        status: 1,
                        bindCode: ''
                    },
                    {
                        propertyName: ' 是否关闭入口',
                        propertyValue: '1',
                        propertyRemark: '是否关闭入口，1关闭，0否',
                        propertyId: '',
                        propertyKey: 'closeOrderBuy',
                        status: 1,
                        bindCode: ''
                    },{
                    propertyName: ' 手机号',
                    propertyValue: '[{"name":"李好","m":"18918976956"},{"name":"李姐","m":"18918976957"}]',
                    propertyRemark: '线下兑换促销员手机号',
                    propertyId: '',
                    propertyKey: 'salesPersonMoblie',
                    status: 1,
                    bindCode: this.$route.query.bindCode
                  },{
                    propertyName: ' 线下兑换点',
                    propertyValue: '[{"name":"北京","shopList":[{"name":"loe北京国贸三期店"},{"name":"7 fresh北京五彩城店"},{"name":"7f resh北京广安门店"},{"name":"7f resh北京时代lift店"},{"name":"7f resh北京泰禾中央广场店"}]},{"name":"沈阳","shopList":[{"name":"loe沈阳万象城店"}]}]',
                    propertyRemark: '线下兑换点',
                    propertyId: '',
                    propertyKey: 'rechangeAddress',
                    status: 1,
                    bindCode:this.$route.query.bindCode
                  }
                ],
                reuionActivePropertyList:[],
                showDialog: false,
                loading: true,
                readOnly:false,
              isEdit:true
            }
        },
        //挂载时候执行
        mounted(){
            this.getList();

        },
        computed: {},
        methods: {
          onChange(){
            if(this.propertyKey!=''){
              var c=this.selectlist.find(item => item.propertyKey ==this.propertyKey );
              if(c!=null&&c!=undefined){
                this.activeProperty=JSON.parse(JSON.stringify(c));
                this.readOnly=true;
              }else{
                this.readOnly=false;
                this.activeProperty.propertyName='';
                this.activeProperty.propertyKey='';
                this.activeProperty.propertyValue-='';
                this.activeProperty.propertyRemark='';
              }
              this.activeProperty.bindCode=this.$route.query.bindCode;
            }else{
              this.readOnly=false;
              this.activeProperty.propertyName='';
              this.activeProperty.propertyKey='';
              this.activeProperty.propertyValue-='';
              this.activeProperty.propertyRemark='';
            }

          },
            addProperty(){
              this.activeProperty.propertyName='';
              this.activeProperty.propertyKey='';
              this.activeProperty.propertyValue-='';
              this.activeProperty.propertyRemark='';
              this.propertyKey='';
              this.showDialog = true;
            },

            getList(){
                this.loading = true
                getActivePropertyList({bindCode: this.$route.query.bindCode}).then((res) => {
                    console.log(res);
                    this.loading = false;
                    if (res.data.status == 200) {
                      this.list = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            returnHistory(){
                window.history.back()
            },
            saveActivePropertyForList(data){
              this.loading = true;
              saveActivePropertyApi(data).then((res) => {
                this.loading = false;
                if (res.data.status == 200) {
                  this.$message({
                    message: '保存成功',
                    type: 'success'
                  });
                  this.getList();
                  this.showDialog=false;
                } else {
                  this.$message({
                    showClose: true,
                    message: res.data.message,
                    type: 'error'
                  });
                }
              });
            },
            saveActiveProperty(data){
              this.$refs["activeProperty"].validate((valid) => {
                if (valid) {
                  this.loading = true;
                  saveActivePropertyApi(data).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                      this.$message({
                        message: '保存成功',
                        type: 'success'
                      });
                      this.getList();
                      this.showDialog=false;
                    } else {
                      this.$message({
                        showClose: true,
                        message: res.data.message,
                        type: 'error'
                      });
                    }
                  });

                } else {
                  console.log('error submit!!');
                  return false;
                }
              });

            },
          deleteActiveProperty(data){
            this.$confirm('删除不可撤销, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.loading = true;
              deleteActivePropertyApi(data).then((res) => {
                this.loading = false;
                if (res.data.status == 200) {
                  this.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getList();
                  this.showDialog = false;
                } else {
                  this.$message({
                    showClose: true,
                    message: res.data.message,
                    type: 'error'
                  });
                }
              });
            });
          },
            saveActivePropertyList(){
                this.loading = true;
                saveActivePropertyListApi({itemList: encodeURIComponent(JSON.stringify(this.list))}).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.showDialog = false;
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },

            handlePic(row){
                let routerL = '/' + this.$route.path.split('/')[1];
                this.$router.push({
                    path: routerL + '/picture/' + row.bindCode,
                    query: {picType: '15', picName: row.proName, picState: 'product'}
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/active/inviteGiftPropertyList.vue